import name from './name'

const selectSliceData = state => state[name]

const selectFilters = state => selectSliceData(state).filters

export { selectFilters }
